import { ImageDrawer } from "./ImageDrawer";
export async function loadImageShape(engine) {
    await engine.addShape(["image", "images"], new ImageDrawer());
}
